/**
 * Minutes as something a person reads at a glance: "45m", "2h 10m", "3h".
 * Null renders as a dash, because "no measured stage" is not "zero minutes".
 */
export function formatMinutes(minutes: number | null | undefined): string {
  if (minutes == null) return '-'
  if (minutes < 60) return `${minutes}m`

  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return rest === 0 ? `${hours}h` : `${hours}h ${rest}m`
}
